import React from 'react'

export const Divider: React.FC = () => {
  return <div className="w-full h-px bg-silver-200 my-4"></div>
}

export default Divider
